import React, {useState} from 'react';
import {ITemplate} from "../../ModelContracts";
import {Button, Modal} from "../ui";
import Labels from "../Labels/Labels";
import {useSearchParams} from "react-router-dom";

import './TemplateCard.css';
import useApi from "../../hooks/useApi/useApi";
import {useMutation, useQueryClient} from "react-query";

interface IProps {
	template: ITemplate
}

function TemplateCard({template}: IProps) {
	const [searchParams, setSearchParams] = useSearchParams();
	const [isRemoving, setIsRemoving] = useState(false);
	const {removeTemplate} = useApi();
	const queryClient = useQueryClient();
	const removeTemplateCommand = useMutation(() => removeTemplate(template.id), {
		onSuccess: async () => {
			await queryClient.invalidateQueries('templates');
		}
	});

	const handleViewClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		const params = searchParams;
		params.append('id', template.id);
		setSearchParams(params);
	};

	const handleEditClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		const params = searchParams;
		params.append('id', template.id);
		params.append('edit', 'true');
		setSearchParams(params);
	};

	const handleStartRemoveClick = () => {
		setIsRemoving(true);
	};

	const handleRemoveClick = () => {
		removeTemplateCommand.mutate();
		setIsRemoving(false);
	};

	const handleCancelClick = () => {
		setIsRemoving(false);
	};

	return (
		<>
			<div className="card bg-base-200 shadow-sm border border-base-300 template-card" role="listitem" aria-label={template.name}>
				<div className="card-body flex flex-row p-0">
					<div className="relative grow pt-2 pb-6 px-2">
						<h5 className="card-title text-base">{template.name}</h5>
						<Labels labels={template.labels} maxCharacterCount={15}/>
					</div>
					<div className="card-options flex flex-col-reverse p-2">
						<Button variant="link" title="Edit Task" onClick={handleEditClick}>
							<i className="bi bi-pencil"></i>
							Edit
						</Button>
						<Button variant="link" title="View" onClick={handleViewClick}>
							<i className="bi bi-binoculars"></i>
							View
						</Button>
						<Button variant="link" title="Delete" onClick={handleStartRemoveClick}>
							<i className="bi bi-trash"></i>
							Delete
						</Button>
					</div>
				</div>
			</div>
			<Modal show={isRemoving} role="dialog" aria-label="Remove Template" onHide={handleCancelClick}>
				<Modal.Header closeButton>
					<Modal.Title role="heading">Remove Template</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>Are you sure you want to remove the template?</p>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="link" onClick={handleCancelClick}>Cancel</Button>
					<Button variant="primary" onClick={handleRemoveClick}>Remove</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default TemplateCard;
